import {
  A3series,
  Antena3,
  Bemad,
  Boing,
  Clan,
  Cuatro,
  Discovery,
  Disney,
  Divinity,
  Dkiss,
  Energy,
  FactoriaFiccion,
  Forta,
  Gol,
  LaSexta,
  Mega,
  Neox,
  Nova,
  Pago,
  Paramount,
  RealMadrid,
  Resto,
  Tdp,
  Telecinco,
  Tematicas,
  Ten,
  TreceTv,
  Tv24h,
  La1,
  La2
} from '../../assets/images/index';

const ANTENA_3_NAME = 'antena3';
const TELECINCO_NAME = 'telecinco';
const LA_1_NAME = 'la1';
const LA_SEXTA_NAME = 'laSexta';
const CUATRO_NAME = 'cuatro';
const NEOX_NAME = 'neox';
const NOVA_NAME = 'nova';
const MEGA_NAME = 'mega';
const ATRESSERIES_NAME = 'a3series';
const FACTORIA_NAME = 'factoriaFiccion';
const DIVINITY_NAME = 'divinity';
const ENERGY_NAME = 'energy';
const BEMAD_NAME = 'bemad';
const BOING_NAME = 'boing';
const FORTA_NAME = 'forta';
const LA_2_NAME = 'la2';
const CLAN_NAME = 'clan';
const TDP_NAME = 'tdp';
const TV24H_NAME = 'tv24h';
const TV13_NAME = 'treceTv';
const DISNEY_NAME = 'disney';
const DISCOVERY_MAX_NAME = 'discovery';
const PARAMOUNT_NAME = 'paramount';
const TEN_NAME = 'ten';
const DKISS_NAME = 'dkiss';
const REAL_MADRID_NAME = 'realMadrid';
const GOL_NAME = 'gol';
const TEMATICAS_NAME = 'tematicas';
const PAGO_NAME = 'pago';
const RESTO_NAME = 'resto';

const ANTENA_3_NAME_RANKING = 'antena3';
const TELECINCO_NAME_RANKING = 'telecinco';
const LA_1_NAME_RANKING = 'la1';
const LA_SEXTA_NAME_RANKING = 'laSexta';
const CUATRO_NAME_RANKING = 'cuatro';
const NEOX_NAME_RANKING = 'neox';
const NOVA_NAME_RANKING = 'nova';
const MEGA_NAME_RANKING = 'mega';
const ATRESSERIES_NAME_RANKING = 'a3series';
const FACTORIA_NAME_RANKING = 'factoriaFiccion';
const DIVINITY_NAME_RANKING = 'divinity';
const ENERGY_NAME_RANKING = 'energy';
const BEMAD_NAME_RANKING = 'bemad';
const BOING_NAME_RANKING = 'boing';
const FORTA_NAME_RANKING = 'forta';
const LA_2_NAME_RANKING = 'la2';
const CLAN_NAME_RANKING = 'clan';
const TDP_NAME_RANKING = 'tdp';
const TV24H_NAME_RANKING = 'tv24h';
const TV13_NAME_RANKING = 'treceTv';
const DISNEY_NAME_RANKING = 'disney';
const DISCOVERY_MAX_NAME_RANKING = 'Discovery';
const PARAMOUNT_NAME_RANKING = 'paramount';
const TEN_NAME_RANKING = 'ten';
const DKISS_NAME_RANKING = 'dkiss';
const REAL_MADRID_NAME_RANKING = 'RM';
const GOL_NAME_RANKING = 'gol';
const TEMATICAS_NAME_RANKING = 'tematicas';
const PAGO_NAME_RANKING = 'pago';
const RESTO_NAME_RANKING = 'resto';

const ANTENA_3_NAME_PRESS_RELEASE = 'antena3';
const TELECINCO_NAME_PRESS_RELEASE = 'telecinco';
const LA_1_NAME_PRESS_RELEASE = 'la1';
const LA_SEXTA_NAME_PRESS_RELEASE = 'laSexta';
const CUATRO_NAME_PRESS_RELEASE = 'cuatro';
const NEOX_NAME_PRESS_RELEASE = 'neox';
const NOVA_NAME_PRESS_RELEASE = 'nova';
const MEGA_NAME_PRESS_RELEASE = 'mega';
const ATRESSERIES_NAME_PRESS_RELEASE = 'atresseries';
const FACTORIA_NAME_PRESS_RELEASE = 'factoríaDeFiccion';
const DIVINITY_NAME_PRESS_RELEASE = 'divinity';
const ENERGY_NAME_PRESS_RELEASE = 'energy';
const BEMAD_NAME_PRESS_RELEASE = 'beMad';
const BOING_NAME_PRESS_RELEASE = 'boing';
const FORTA_NAME_PRESS_RELEASE = 'forta';
const LA_2_NAME_PRESS_RELEASE = 'la2';
const CLAN_NAME_PRESS_RELEASE = 'clan';
const TDP_NAME_PRESS_RELEASE = 'teledeporte';
const TV24H_NAME_PRESS_RELEASE = '24h';
const TV13_NAME_PRESS_RELEASE = '13Tv';
const DISNEY_NAME_PRESS_RELEASE = 'disneyChannel';
const DISCOVERY_MAX_NAME_PRESS_RELEASE = 'discoveryMax';
const PARAMOUNT_NAME_PRESS_RELEASE = 'paramount';
const TEN_NAME_PRESS_RELEASE = 'ten';
const DKISS_NAME_PRESS_RELEASE = 'dkiss';
const REAL_MADRID_NAME_PRESS_RELEASE = 'realMadridTV';
const GOL_NAME_PRESS_RELEASE = 'gol';
const TEMATICAS_NAME_PRESS_RELEASE = 'tematicas';
const PAGO_NAME_PRESS_RELEASE = 'pago';
const RESTO_NAME_PRESS_RELEASE = 'resto';

const CHANNELS = [
  ANTENA_3_NAME,
  TELECINCO_NAME,
  LA_1_NAME,
  LA_SEXTA_NAME,
  CUATRO_NAME,
  NEOX_NAME,
  NOVA_NAME,
  MEGA_NAME,
  ATRESSERIES_NAME,
  FACTORIA_NAME,
  DIVINITY_NAME,
  ENERGY_NAME,
  BEMAD_NAME,
  BOING_NAME,
  FORTA_NAME,
  LA_2_NAME,
  CLAN_NAME,
  TDP_NAME,
  TV24H_NAME,
  TV13_NAME,
  DISNEY_NAME,
  DISCOVERY_MAX_NAME,
  PARAMOUNT_NAME,
  TEN_NAME,
  DKISS_NAME,
  REAL_MADRID_NAME,
  GOL_NAME,
  TEMATICAS_NAME,
  PAGO_NAME,
  RESTO_NAME
];

const CHANNELS_ICON = {
  [ANTENA_3_NAME]: { icon: Antena3 },
  [TELECINCO_NAME]: { icon: Telecinco },
  [LA_1_NAME]: { icon: La1 },
  [LA_SEXTA_NAME]: { icon: LaSexta },
  [CUATRO_NAME]: { icon: Cuatro },
  [NEOX_NAME]: { icon: Neox },
  [NOVA_NAME]: { icon: Nova },
  [MEGA_NAME]: { icon: Mega },
  [ATRESSERIES_NAME]: { icon: A3series },
  [FACTORIA_NAME]: { icon: FactoriaFiccion },
  [DIVINITY_NAME]: { icon: Divinity },
  [ENERGY_NAME]: { icon: Energy },
  [BEMAD_NAME]: { icon: Bemad },
  [BOING_NAME]: { icon: Boing },
  [FORTA_NAME]: { icon: Forta },
  [LA_2_NAME]: { icon: La2 },
  [CLAN_NAME]: { icon: Clan },
  [TDP_NAME]: { icon: Tdp },
  [TV24H_NAME]: { icon: Tv24h },
  [TV13_NAME]: { icon: TreceTv },
  [DISNEY_NAME]: { icon: Disney },
  [DISCOVERY_MAX_NAME]: { icon: Discovery },
  [PARAMOUNT_NAME]: { icon: Paramount },
  [TEN_NAME]: { icon: Ten },
  [DKISS_NAME]: { icon: Dkiss },
  [REAL_MADRID_NAME]: { icon: RealMadrid },
  [GOL_NAME]: { icon: Gol },
  [TEMATICAS_NAME]: { icon: Tematicas },
  [PAGO_NAME]: { icon: Pago },
  [RESTO_NAME]: { icon: Resto }
};

const CHANNELS_ICON_RANKING = {
  [ANTENA_3_NAME_RANKING]: { icon: Antena3 },
  [TELECINCO_NAME_RANKING]: { icon: Telecinco },
  [LA_1_NAME_RANKING]: { icon: La1 },
  [LA_SEXTA_NAME_RANKING]: { icon: LaSexta },
  [CUATRO_NAME_RANKING]: { icon: Cuatro },
  [NEOX_NAME_RANKING]: { icon: Neox },
  [NOVA_NAME_RANKING]: { icon: Nova },
  [MEGA_NAME_RANKING]: { icon: Mega },
  [ATRESSERIES_NAME_RANKING]: { icon: A3series },
  [FACTORIA_NAME_RANKING]: { icon: FactoriaFiccion },
  [DIVINITY_NAME_RANKING]: { icon: Divinity },
  [ENERGY_NAME_RANKING]: { icon: Energy },
  [BEMAD_NAME_RANKING]: { icon: Bemad },
  [BOING_NAME_RANKING]: { icon: Boing },
  [FORTA_NAME_RANKING]: { icon: Forta },
  [LA_2_NAME_RANKING]: { icon: La2 },
  [CLAN_NAME_RANKING]: { icon: Clan },
  [TDP_NAME_RANKING]: { icon: Tdp },
  [TV24H_NAME_RANKING]: { icon: Tv24h },
  [TV13_NAME_RANKING]: { icon: TreceTv },
  [DISNEY_NAME_RANKING]: { icon: Disney },
  [DISCOVERY_MAX_NAME_RANKING]: { icon: Discovery },
  [PARAMOUNT_NAME_RANKING]: { icon: Paramount },
  [TEN_NAME_RANKING]: { icon: Ten },
  [DKISS_NAME_RANKING]: { icon: Dkiss },
  [REAL_MADRID_NAME_RANKING]: { icon: RealMadrid },
  [GOL_NAME_RANKING]: { icon: Gol },
  [TEMATICAS_NAME_RANKING]: { icon: Tematicas },
  [PAGO_NAME_RANKING]: { icon: Pago },
  [RESTO_NAME_RANKING]: { icon: Resto }
};

const CHANNELS_ICON_PRESS_RELEASE = {
  [ANTENA_3_NAME_PRESS_RELEASE]: { icon: Antena3 },
  [TELECINCO_NAME_PRESS_RELEASE]: { icon: Telecinco },
  [LA_1_NAME_PRESS_RELEASE]: { icon: La1 },
  [LA_SEXTA_NAME_PRESS_RELEASE]: { icon: LaSexta },
  [CUATRO_NAME_PRESS_RELEASE]: { icon: Cuatro },
  [NEOX_NAME_PRESS_RELEASE]: { icon: Neox },
  [NOVA_NAME_PRESS_RELEASE]: { icon: Nova },
  [MEGA_NAME_PRESS_RELEASE]: { icon: Mega },
  [ATRESSERIES_NAME_PRESS_RELEASE]: { icon: A3series },
  [FACTORIA_NAME_PRESS_RELEASE]: { icon: FactoriaFiccion },
  [DIVINITY_NAME_PRESS_RELEASE]: { icon: Divinity },
  [ENERGY_NAME_PRESS_RELEASE]: { icon: Energy },
  [BEMAD_NAME_PRESS_RELEASE]: { icon: Bemad },
  [BOING_NAME_PRESS_RELEASE]: { icon: Boing },
  [FORTA_NAME_PRESS_RELEASE]: { icon: Forta },
  [LA_2_NAME_PRESS_RELEASE]: { icon: La2 },
  [CLAN_NAME_PRESS_RELEASE]: { icon: Clan },
  [TDP_NAME_PRESS_RELEASE]: { icon: Tdp },
  [TV24H_NAME_PRESS_RELEASE]: { icon: Tv24h },
  [TV13_NAME_PRESS_RELEASE]: { icon: TreceTv },
  [DISNEY_NAME_PRESS_RELEASE]: { icon: Disney },
  [DISCOVERY_MAX_NAME_PRESS_RELEASE]: { icon: Discovery },
  [PARAMOUNT_NAME_PRESS_RELEASE]: { icon: Paramount },
  [TEN_NAME_PRESS_RELEASE]: { icon: Ten },
  [DKISS_NAME_PRESS_RELEASE]: { icon: Dkiss },
  [REAL_MADRID_NAME_PRESS_RELEASE]: { icon: RealMadrid },
  [GOL_NAME_PRESS_RELEASE]: { icon: Gol },
  [TEMATICAS_NAME_PRESS_RELEASE]: { icon: Tematicas },
  [PAGO_NAME_PRESS_RELEASE]: { icon: Pago },
  [RESTO_NAME_PRESS_RELEASE]: { icon: Resto }
};

export {
  CHANNELS,
  CHANNELS_ICON,
  CHANNELS_ICON_RANKING,
  CHANNELS_ICON_PRESS_RELEASE
};
